import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiPartner';
export const ENDPOINT_API_PATH = '/v1/partners/token';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType =
  'TOKEN_AUTH_USER_OR_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/7210a7e8-73a2-45a0-9b87-c048466ddeee?version=31e9deda-e2ea-4d4b-becb-e3e5165753fd&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '',
    bussinessErrorVariant: 'errorService',
    message: 'Ocorreu um erro ao gerar token',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};
